"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generateNewTag_1 = require("./generateNewTag");
function flattenPlacements(mediumGroups) {
    var result = mediumGroups.reduce(function (placements, mediumGroup) {
        return placements.concat(mediumGroup.mediumGroup);
    }, []);
    result.forEach(function (item) {
        if (!item.tag) {
            item.tag = generateNewTag_1.generateNewTag();
        }
    });
    return result;
}
exports.flattenPlacements = flattenPlacements;
//# sourceMappingURL=flattenPlacements.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/posterControllerSupportingClasses/flattenPlacements.js
// module id = 61
// module chunks = 0